import { postMethod } from "../../../../function/helper";
import Swal from "sweetalert2";

const doSubmit = async (data, showModal, loading) => {
  const sumbitData = {
    ...data,
    email: data.email ? data.email : undefined,
    password_confirmation: data.confirmPassword,
  };

  loading(true);
  const response = await postMethod("/user/v1/register-agent", sumbitData);
  loading(false);

  if (response && response.status === 200) {
    showModal();
    return;
  }

  Swal.fire({
    icon: "error",
    text: response.message,
    showConfirmButton: true,
    confirmButtonText: response.data?.redirect
      ? "هدایت به صفحه ی ورود"
      : "متوجه شدم",
    showCancelButton: true,
    cancelButtonText: "لغو",
  }).then(res => {
    if (res.isConfirmed && response.data?.redirect) {
      window.location.href = response.data.redirect;
    }
  });
};

export default doSubmit;
